import {IsNotEmpty, IsOptional} from "class-validator";
import {MeetsPasswordCriteria} from "../../validators/meetsPasswordCriteria.validator";

class PasswordReset {

    @MeetsPasswordCriteria({message: "Please enter a password that meets the requirements"})
    @IsNotEmpty({message: "Please enter a new password"})
    password: string;
    
    @IsOptional()
    resetToken?: string;
}

export { PasswordReset }